import React, { useEffect } from "react";
import { useState } from "react";

import axios from "axios";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import ChangePasswordDialog from "../../AuthComponents/ChangePasswordDialog";

type ProfileSecurityPaperProps = {
  locked: boolean;
};

function ProfileSecurityPaper(props: ProfileSecurityPaperProps) {
  const [changePasswordDialogOpen, setChangePasswordDialogOpen] = useState(false);

  return (
    <>
      <Stack
        direction="column"
        width="100%"
        flexWrap="wrap"
        sx={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-start",
          gap: 1,
        }}
      >
        <Typography variant="h5" noWrap sx={{ color: "info.main", alignSelf: "flex-start" }}>
          Account Settings
        </Typography>

        {/*}TODO: Position a card with "absolute" and the same size. Higher z index, and then opacity like e 0.15 to gray it out?  */}
        {[
          {
            text: "Update Email",
            action: undefined, // TODO: implement
          },
          {
            text: "Change Username",
            action: undefined, // TODO: implement
          },
          {
            text: "Change My Password",
            action: () => setChangePasswordDialogOpen(true),
          },
        ].map((button_details, index) => (
          <Button
            key={index}
            size="small"
            disabled={props.locked || button_details.action === undefined}
            onClick={() => button_details.action !== undefined && button_details.action()}
            sx={{ whiteSpace: "nowrap" }}
          >
            {button_details.text}
          </Button>
        ))}
      </Stack>
      <ChangePasswordDialog open={changePasswordDialogOpen} close={() => setChangePasswordDialogOpen(false)} />
    </>
  );
}

export default ProfileSecurityPaper;
